var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6061 3.35878C17.7462 3.78015 16.9034 3.95128 16.0263 4.21013C15.0623 3.1223 13.6331 3.0621 12.2597 3.57635C10.8864 4.09059 9.9869 5.34783 10.0067 6.78996V7.64991C7.21615 7.72128 4.73091 6.45028 3.12712 4.21013C3.12712 4.21013 -0.469173 10.6021 6.5669 13.6695C4.95708 14.7419 3.35156 15.4651 1.40723 15.3894C4.25192 16.9399 7.35203 17.4731 10.0359 16.6939C13.1145 15.7996 15.6445 13.4924 16.6154 10.0363C16.905 8.98512 17.0488 7.89917 17.0427 6.80888C17.041 6.59475 18.3413 4.42511 18.6061 3.35792V3.35878Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.28992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.69c52abd101d2f55f2c5a3e990b1a439.svg";
export { ForwardRef as ReactComponent };